import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, from, map, of, switchMap } from 'rxjs';

import { DataRepository } from '@core/data/data-repository';
import { TimeOffApiActions, TimeOffPageActions } from './time-off.actions';

/** Bridges time-off actions to the data layer. Decisions stay in the reducer. */
@Injectable()
export class TimeOffEffects {
  private readonly actions$ = inject(Actions);
  private readonly repo = inject(DataRepository);

  readonly load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TimeOffPageActions.entered),
      switchMap(() =>
        from(this.repo.listTimeOff()).pipe(
          map((requests) => TimeOffApiActions.loadSuccess({ requests })),
          catchError((err: unknown) => of(TimeOffApiActions.loadFailure({ error: toMessage(err) }))),
        ),
      ),
    ),
  );
}

function toMessage(err: unknown): string {
  return err instanceof Error ? err.message : 'Unknown error';
}
